export default __webpack_public_path__ + "static/artifakt-element-light-b31732471c75cdd7f910df20db0c8168.svg";